import React, { useEffect, useCallback, useState } from "react";

import { projects } from "../../data/projects";
import { Icon } from "@iconify/react";
import { ProjectTag } from "../../data/enum";
import { FaRegEye, FaCode } from "react-icons/fa6";
interface projectProp {
  name: string;
  description: string;
  technologies: string[];
  liveURL: string;
  srcCodeURL?: string;
  width: number;
  imgURL?: string;
  tag: Array<ProjectTag>;
}
const Project = ({
  name,
  description,
  technologies,
  liveURL,
  srcCodeURL,
  imgURL,
  tag,
}: projectProp) => {
  return (
    <div
      className={
        "p-4 rounded-2xl bg-[#000e29d9] shadow-sm shadow-white/10 border-[1px] border-solid border-white/10 mx-auto w-full max-w-[900px]"
      }
    >
      {!imgURL ? null : (
        <div className="rounded-2xl border-[1px] border-solid border-gray-700/50 mb-4 overflow-hidden w-full  ">
          <img
            src={imgURL}
            alt={name + " screenshot "}
            className="w-full h-[300px] object-cover"
          />
        </div>
      )}
      <div className="px-2 md:px-4 py-4">
        <h3 className="text-base md:text-xl font-[600] text-primary-500 font-lato tracking-wide">
          {name}{" "}
        </h3>
        <p className="text-base md:text-base mb-4 mt-2 tracking-wide flex gap-2">
          <span>{tag.length < 2 ? "Tags: " : "Tags: "} </span>
          <span className="text-primary-500">{tag.join(", ")}</span>
        </p>
        <p className="text-base font-medium flex gap-2 flex-wrap ">
          {technologies.map((tech, i) => (
            <span
              className="text-white py-1 px-3 md:py-2 md:px-4  bg-primary-500/10 rounded-md font-semibold tracking-wide"
              key={tech + i}
            >
              {tech}
            </span>
          ))}
        </p>
        <p className="text-lg md:text-lg tracking-wide text-justify   leading-[2] md:leading-[2.5]  my-8">
          {description}
        </p>
        <p className="flex gap-2 text-sm justify-center md:justify-start">
          {liveURL && (
            <a
              href={liveURL}
              className="flex gap-2 border-[1px] border-primary-500/20 py-2 px-4 rounded-lg text-primary-500 font-nunito font-medium items-center hover:border-primary-500 active:translate-x-0 transition-all duration-300"
              target={"_blank"}
              rel="noopener noreferrer"
            >
              <FaRegEye className="" />

              <span> View</span>
            </a>
          )}

          {srcCodeURL && (
            <a
              href={srcCodeURL}
              target={"_blank"}
              className="flex gap-2 border-[1px] border-primary-500/20 py-2 px-4 rounded-lg text-primary-500 font-lato items-center hover:border-primary-500 active:translate-x-0 transition-all duration-300"
              rel="noopener noreferrer"
            >
              <FaCode />
              <span>Code</span>
            </a>
          )}
        </p>
      </div>
    </div>
  );
};

export const ProjectsContent: React.FC = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const handleWidth = useCallback(() => setWidth(window.innerWidth), []);
  useEffect(() => {
    window.addEventListener("resize", handleWidth);
    return () => window.removeEventListener("resize", handleWidth);
  }, [handleWidth]);
  return (
    <div
      className={
        "flex pt-[5rem] pb-[10rem] md:pt-[10rem] flex-col gap-4 py-4 px-[7.5%] text-[#f7f7f7] font-nunito"
      }
    >
      <div className="max-w-[1000px] mx-auto w-[100%]">
        <h1 className="text-base md:text-xl lg:text-2xl tracking-wider font-semibold text-primary-500">
          Personal Projects
        </h1>
        <p className="text-base mt-4 md:text-xl tracking-wide">
          I enjoy turning concepts into real-world applications. Here are a few
          notable projects I’ve worked on.
        </p>
        <div className="flex flex-col gap-16 mt-10">
          {/* PROJECTS CONTAINER */}
          {projects.map((project, index) => (
            <Project
              key={index}
              imgURL={project.imgURL}
              width={width}
              name={project.name}
              description={project.description}
              technologies={project.technologies}
              liveURL={project?.liveURL || ""}
              srcCodeURL={project.srcCodeURL}
              tag={project.tag}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
